import {LOAD_DATA, START, SUCCESS, FAIL, CHANGE_LOCATION, ITEM, STORE} from "../constants";

const cache = {};

export default (store) => (next) => (action) => {
  next(action)

  const {callAPI, payload, type, ...rest} = action;

  if (type !== CHANGE_LOCATION) return

  const url = payload.location.pathname + payload.location.search + payload.location.hash
  let scope

  if (/edit_v2|new_v2/.test(url)) return

  if (/store/.test(url)) scope = STORE
  if (/\/\w+\/\d+/.test(url)) scope = ITEM
  else scope = STORE

  store.dispatch({
    type: scope + LOAD_DATA + START,
    payload,
    ...rest
  });

  if (cache[url]) {
    store.dispatch({
      ...rest,
      payload,
      response: {...(cache[url].state || cache[url])},
      type: scope + LOAD_DATA + SUCCESS
    });
  } else {
    fetch(url, {
      headers: {
        "Accept": 'application/json',
        "Content-Type": 'application/json'
      },
      credentials: 'same-origin'
    })
      .then((res) => {
        if (res.status >= 400) {
          throw new Error('Error');
        }
        return res.json();
      })
      .then((response) => {
        cache[url] = {...response}; // add to local cache
        store.dispatch({
          ...rest,
          payload,
          response: response.state || response,
          type: scope + LOAD_DATA + SUCCESS
        });
      })
      .catch((error) => store.dispatch({...rest, payload, error, type: scope + LOAD_DATA + FAIL}));
  }

  return void 0;
};
